import { useState, useEffect } from 'react';

/**
 * A hook that constructs intro messages for search results chatbot
 * based on the provided travelOptions data.
 */
const useHotelsSearchResultsExtractor = ({ generalInfo }) => {
  const [introMessage, setIntroMessage] = useState();
  const [error, setError] = useState(null);
  const [extractTriggered, setExtractTriggered] = useState(false);

  const instruction = generalInfo;
  useEffect(() => {
    setExtractTriggered(false);
    setIntroMessage(instruction);
  }, [extractTriggered, instruction, setIntroMessage]);

  return {
    introMessage,
    triggerExtract: setExtractTriggered,
    extractorError: error,
    setExtractorError: setError,
  };
};

export default useHotelsSearchResultsExtractor;
